import styled, { css } from 'styled-components';
import { Button, Input, Label, Text } from '@appcues/sonar';
import { CopyToClipboard } from 'studio5/components';

const INLINE = 'inline';
export const INPUT = 'input';
export const CODE = 'code';

const REGULAR = 'regular';
export const SMALL = 'small';

const InlineWrapper = styled.div<{ isCode: boolean }>`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: var(--spacing-x-small);

  ${Button} {
    min-width: 24px;
    width: 24px;
    height: 24px;
    padding: var(--spacing-regular);
    border: none;
  }

  ${({ isCode }) =>
    isCode &&
    css`
      background-color: var(--background-default-base);
      border: 1px solid var(--border-input-read-only);
      border-radius: var(--border-radius-small);
      padding-left: var(--spacing-small);
    `}
`;

const InputWrapper = styled.div`
  display: flex;
  gap: var(--spacing-small);

  ${Input} {
    flex: 1;
  }
`;

type Props = {
  label?: string;
  value: string;
  size?: typeof REGULAR | typeof SMALL;
  variant?: typeof CODE | typeof INLINE | typeof INPUT;
};

function CopyToClipboardWithValue({
  label,
  value,
  size = REGULAR,
  variant = INLINE,
}: Props) {
  const InlineClickToCopy = (
    <InlineWrapper isCode={variant === CODE}>
      {label && (
        <Text weight="bold" size={size}>
          {label}
        </Text>
      )}
      <Text size={size}>{value}</Text>
      <CopyToClipboard value={value} />
    </InlineWrapper>
  );

  const InputClickToCopy = (
    <>
      <Label htmlFor="click-to-copy">{label}</Label>
      <InputWrapper>
        <Input id="click-to-copy" value={value} readOnly />
        <CopyToClipboard value={value} />
      </InputWrapper>
    </>
  );

  return variant === INLINE || variant === CODE
    ? InlineClickToCopy
    : InputClickToCopy;
}

export default CopyToClipboardWithValue;
